import React, { FC, useMemo } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useField } from "formik";
import { IFormField, ISelectOption } from "src/@types/form";
import { FormField } from ".";
import { Select } from "../Select";

export const MultiSelectField: FC<IFormField> = ({
  className,
  fieldClassName,
  labelClassName,
  id,
  label,
  variant,
  placeholder,
  errorClassName,
  options,
  ...props
}) => {
  const { t } = useTranslation();

  const name = props.name as string;

  const fieldId = id || name;

  const [{ value, ...field }, { error, touched }, { setValue, setTouched }] =
    useField<ISelectOption["value"][]>(fieldId);

  const isShownError = Boolean((touched || value.length) && error);

  const onChange = (options: ISelectOption[]) => {
    const optionsValues = options.map((option) => option.value);
    setValue(optionsValues);
  };

  const onBlur = () => setTouched(true);

  const placeholderText =
    typeof placeholder === "string"
      ? placeholder
      : placeholder && t(placeholder.i18nKey, placeholder.i18nParams);

  const activeValues = useMemo(
    () => options.filter((option) => value.includes(option.value)),
    [options, value]
  );

  return (
    <FormField
      className={fieldClassName}
      labelClassName={labelClassName}
      variant={variant}
      label={label}
      labelFor={fieldId}
      isShownError={isShownError}
      error={error}
      errorClassName={errorClassName}
    >
      <Select
        {...props}
        {...field}
        id={fieldId}
        className={cn("w-full", className)}
        placeholder={placeholderText}
        value={activeValues}
        isMulti={true}
        options={options}
        onBlur={onBlur}
        onChange={onChange}

        // onKeyDown={onKeyDownEnter}
      />
    </FormField>
  );
};
